import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";

const Footer = () => {
  const { t } = useI18n();
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-[#3A3E43] py-12 bg-[#1A1C1F]">
      <div className="max-w-[1500px] mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <div className="w-7 h-7 bg-[#C2674A] flex items-center justify-center">
            <span className="text-black font-heading font-black text-sm">L</span>
          </div>
          <div>
            <div className="font-heading font-black tracking-[0.3em] text-white">
              LìBER
            </div>
            <div className="text-xs text-[#A0A0A0] mt-0.5">{t.footer.tagline}</div>
          </div>
        </div>
        <div className="flex flex-col md:items-end gap-2 font-mono text-xs text-[#A0A0A0] tracking-wider">
          <nav className="flex gap-5" data-testid="footer-legal-links">
            <Link to="/imprint" className="hover:text-white transition-colors duration-200">
              {t.footer.imprint}
            </Link>
            <Link to="/privacy" className="hover:text-white transition-colors duration-200">
              {t.footer.privacy}
            </Link>
          </nav>
          <div>
            © {year} Spotera Systems SRL — {t.footer.rights}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
